export enum BrowseDataAPIFilterUID {
  Age = 'filter[attribute_values][age][]',
  BeautyIngredients = 'filter[attribute_values][beauty_ingredients][]',
  BodyArea = 'filter[attribute_values][body_area][]',
  BraceletStyle = 'filter[attribute_values][bracelet_style][]',
  Categories = 'filter[category_id]',
  Color = 'filter[attribute_values][colour][]',
  CufflinkStyle = 'filter[attribute_values][cufflink_style][]',
  Delivery = 'filter[delivery][]',
  DeliveryZones = 'filter[delivery_zone]',
  Discount = 'filter[discount][]',
  EarringStyle = 'filter[attribute_values][earring_style][]',
  Fairtrade = 'filter[attribute_values][fairtrade][]',
  Finish = 'filter[attribute_values][finish][]',
  FrameColor = 'filter[attribute_values][frame_colour][]',
  Framing = 'filter[attribute_values][framing][]',
  Gender = 'filter[attribute_values][gender][]',
  Material = 'filter[attribute_values][material][]',
  NecklaceStyle = 'filter[attribute_values][necklace_style][]',
  Organic = 'filter[attribute_values][organic][]',
  Orientation = 'filter[attribute_values][orientation][]',
  Personalisation = 'filter[personalisable]',
  PreciousStone = 'filter[attribute_values][precious_stone][]',
  Price = 'price',
  RingStyle = 'filter[attribute_values][ring_style][]',
  SecondaryColor = 'filter[attribute_values][secondary_colour][]',
  SecondaryMaterial = 'filter[attribute_values][secondary_material][]',
  Size = 'filter[attribute_values][size][]',
  Sort = 'filter[sort]',
  SpecialFeatures = 'filter[special][]',
  Subcategories = 'filter[subcategories][]',
  WineRegion = 'filter[attribute_values][wine_region][]',
  WorldCuisine = 'filter[attribute_values][world_cuisine][]',
}
